<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }"  />
    </div>
    <div class="global-table-container">
      <basic-form
        ref="basicForm"
        :form-data="formData"
      >
        <template #name>
          <a-input
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入企业名称',
                  },
                ],
                initialValue: data.name
              },
            ]"
            :disabled="disabled"
            placeholder="请输入企业名称"
          />
        </template>
        <template #credit_code>
          <a-input
            v-decorator="[
              'credit_code',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入纳税人识别号',
                  },
                ],
                initialValue: data.credit_code
              },
            ]"
            :disabled="disabled"
            placeholder="请输入纳税人识别号"
          />
        </template>
        <template #qichacha_econ_kind>
          <a-input
            v-decorator="[
              'qichacha_econ_kind',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入企业类型',
                  },
                ],
                initialValue: data.qichacha_econ_kind
              },
            ]"
            :disabled="disabled"
            placeholder="请输入企业类型"
          />
        </template>
        <template #qichacha_status>
          <a-input
            v-decorator="[
              'qichacha_status',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入登记状态',
                  },
                ],
                initialValue: data.qichacha_status
              },
            ]"
            :disabled="disabled"
            placeholder="请输入登记状态"
          />
        </template>
		<template #qichacha_regist_capi>
          <a-input
            v-decorator="[
              'qichacha_regist_capi',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入注册资本',
                  },
                ],
                initialValue: data.qichacha_regist_capi
              },
            ]"
            :disabled="disabled"
            placeholder="请输入注册资本"
          />
        </template>
       <template #qichacha_start_date>
		   <a-date-picker
			v-decorator="[
			  'qichacha_start_date',
			  {
			    rules: [
			      {
			        required: true,
			        message: '请输入成立日期',
			      },
			    ],
			    initialValue: data.qichacha_start_date
			  },
			]"
			:disabled="disabled"
			style="width: 100%;"
			class="select-container"
			 placeholder="请选择成立日期"  @change="onOk" />
       </template>
	   <template #oper_name>
	     <a-input
	       v-decorator="[
	         'oper_name',
	         {
	           rules: [
	             {
	               required: true,
	               message: '请输入法定代表人名称',
	             },
	           ],
	           initialValue: data.oper_name
	         },
	       ]"
	       :disabled="disabled"
	       placeholder="请输入法定代表人名称"
	     />
	   </template>
	   <template #qichacha_address>
	     <a-input
	       v-decorator="[
	         'qichacha_address',
	         {
	           rules: [
	             {
	               required: true,
	               message: '请输入注册地址',
	             },
	           ],
	           initialValue: data.qichacha_address
	         },
	       ]"
	       :disabled="disabled"
	       placeholder="请输入注册地址"
	     />
	   </template>
        <template #qichacha_scope>
          <a-textarea
            v-decorator="[
              'qichacha_scope',
              { rules: [{ required: true,
	               message: '请输入经营范围', }],
                initialValue: data.qichacha_scope },
            ]"
            :disabled="disabled"
            rows="6"
            placeholder="请输入"
          />
        </template>
       
        
      </basic-form>
      <div style="text-align:right">
        <a-button @click="onCancel">
          返回
        </a-button>
        <a-button
          :btn-is-loading="btnIsLoading"
          :disabled="disabled"
          type="primary"
          style="margin-left:20px;"
          @click="handleSubmit"
        >
          提交
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
const uuidv1 = require('uuid/v1');
import {formData} from './../data/index';
export default {
  data(){
    return{
      btnIsLoading: false,
      formData,
      typeData: ['输入框', '下拉单选', '单图上传', '多图上传', '地图定位', '日期时间选择', '特殊下拉框', '下拉多选', '数据检索'],
      activityData: [
      ],
      disabled: false,
      selectDisabled: false,
      id: '',
      data: {},
      showData: [],
	  start_date:''
    };
  },
  mounted(){
    // 获取服务活动
    this.getActivity();
    this.getShowData();
    // 查看
    if(this.$route.query&&this.$route.query.disabled==='true'){
      this.disabled=true;
      this.selectDisabled=true;
    }
    // 编辑
    if(this.$route.query&&this.$route.query.id){
      let id=this.$route.query.id;
	  console.log(this.$route)
	  this.$route.meta[1].name='修改企业库'
      this.selectDisabled=true;
      this.getDetails(id);
		
    }else{
		this.$route.meta[1].name='新增企业库'
	}
  },
  methods: {
    // 回显
    async getDetails(id){
      let result = await this.$http.post(
        '/company/getCompanyInfoDetail',
        {id},
      );
      if (result.data.status === 1) {
        let res=result.data.data;
        console.log('TCL: getDetails -> res', res);
		this.start_date=res.qichacha_start_date
        this.data={
			name: res.qichacha_name,
			credit_code: res.qichacha_credit_code,
			qichacha_econ_kind: res.qichacha_econ_kind,
			qichacha_status: res.qichacha_status,
			qichacha_regist_capi: res.qichacha_regist_capi,
			qichacha_start_date:this.$moment(res.qichacha_start_date),
			oper_name: res.qichacha_oper_name,
			qichacha_scope: res.qichacha_scope,
			qichacha_address: res.qichacha_address,
        };
      }
    },
    // 获取服务活动
    async getActivity() {
      this.loading = true;
      let result = await this.$http.post(
        '/Service/getList',
        {page: 0, pageSize: 0},
      );
      if (result.data.status === 1) {
        this.activityData = result.data.data.data_list;
      }
    },
    // 获取是否显示数据
    async getShowData() {
      let result = await this.$http.post(
        '/system/getConfigs',
      );
      if (result.data.status === 1) {
        this.showData = result.data.data.service_form_item_showflag;
        console.log('getShowData -> this.showData', this.showData);
      }
    },
	async onOk(value){
		this.start_date=value.format('YYYY-MM-DD')
	},
    //
    handleSubmit() {
      this.$refs.basicForm.form.validateFields(async(err, values) => {
        console.log('TCL: handleSubmit -> values', values);
        if (!err) {
          this.btnIsLoading=true;
          if(this.$route.query&&this.$route.query.disabled==='false'){
            this.id=this.$route.query.id;
          }
          let data={
            company_id: this.id?this.id:undefined,
            name: values.name,
            credit_code: values.credit_code,
            econ_kind: values.qichacha_econ_kind,
            status: values.qichacha_status,
            regist_capi: values.qichacha_regist_capi,
            start_date: this.start_date,
            oper_name: values.oper_name,
            scope: values.qichacha_scope,
            address: values.qichacha_address,
            config_data: values.config_data,
          };
          let result = await this.$http.post(
            '/company/baseInfo',
            data,
          );
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');

            this.$router.back();
          }
        }
      });
    },
    // 返回
    onCancel(){
      this.$router.back();
    },
  },
};
</script>

<style>

</style>